export const goalOptions = [
    "IPO Readiness",
    "M&A Integration",
    "Regulatory Compliance",
    "Audit Readiness",
    "ESG Reporting",
    "Financial Visibility",
    "Faster Close",
    "Process Automation",
    "Data Integrity",
    "Scale Finance",
    "Risk Reduction",
    "Reduce Manual Work"
];

 // TODO do we want this to be dynamically managed?
export const erpOptions = ["SAP ECC", "SAP S/4HANA", "Oracle EBS", "Oracle Cloud", "Workday", "NetSuite", "Other"]